import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true; // Permitir acceso si el usuario está autenticado
  } else {
    console.log('Acceso denegado');

    router.navigate(['/login-nuevo']); // Redirigir al login si no está autenticado
    return false;
  }
};
